document.addEventListener("DOMContentLoaded", function(){

    
    const totalSlides = document.querySelectorAll('.ingredientSwiper_slider_2 .swiper-slide:not(.swiper-slide-duplicate)').length;
    const init1 = 0;
    const init2 = 2;
    const init3 = 3;
    
    const ingredientSwiper1 = new Swiper(".ingredientSwiper_slider_1", {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        allowTouchMove: false,
        initialSlide: init1,
        spaceBetween: 40,
        breakpoints: {
            800: { slidesPerView: 2 },
            900: { slidesPerView: 2 },
        },
    });

    let ingredientSwiper2 = new Swiper(".ingredientSwiper_slider_2", {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        initialSlide: init2,
        spaceBetween: 40,
        navigation: {
            nextEl: ".ingredient_arrow_right",
            prevEl: ".ingredient_arrow_left",
        },
    });

    const ingredientSwiper3 = new Swiper(".ingredientSwiper_slider_3", {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        allowTouchMove: false,
        initialSlide: init3,
        spaceBetween: 40,
        breakpoints: {
            800: { slidesPerView: 2 },
            900: { slidesPerView: 2 },
        },
    });

    ingredientSwiper2.on("slideChangeTransitionStart", () => {
        ingredientSwiper2.allowTouchMove = false;
    });
    ingredientSwiper2.on("slideChangeTransitionEnd", () => {
        ingredientSwiper2.allowTouchMove = true;
    });
    ingredientSwiper2.on("slideChange", () => {
        const real = ingredientSwiper2.realIndex;
        const targetFor1 = (real - (init2 - init1) + totalSlides) % totalSlides;
        const targetFor3 = (real - (init2 - init3) + totalSlides) % totalSlides;
        ingredientSwiper1.slideToLoop(targetFor1, 1000, false);
        ingredientSwiper3.slideToLoop(targetFor3, 1000, false);
    });
});